module.exports = __webpack_public_path__ + "static/media/viber.55791fa2.svg";